import {FormControlType, IFormConfig, InputType, ValidationRules} from 'marine-panel-common-web';

export const createExtraFormConfig = (): IFormConfig => {
    return {
        controlType: 'form',
        class: 'default-form create-marina',
        dataAccessor: (data: any) => data,
        outputDataMapper: (data: any, previousStateSnapshot: any) => {
            Object.assign(previousStateSnapshot, data);
            return previousStateSnapshot;
        },
        controls: [
            {
                key: 'name',
                controlType: 'group',
                class: 'row',
                controls: {
                    name: {
                        controlType: 'control',
                        formControlType: FormControlType.INPUT,
                        validationRules: [{name: ValidationRules.IS_REQUIRED, params: {}}],
                        placeholder: 'modal.createExtra.placeholders.name',
                        isLabelHidden: false,
                        label: 'modal.createExtra.inputs.name',
                        type: InputType.TEXT,
                        hostClass: 'col-xl-12 form-control',
                    },
                },
            },
            {
                key: 'price',
                controlType: 'group',
                class: 'row',
                controls: {
                    price: {
                        controlType: 'control',
                        formControlType: FormControlType.INPUT,
                        validationRules: [],
                        placeholder: 'modal.createExtra.placeholders.price',
                        isLabelHidden: false,
                        label: 'modal.createExtra.inputs.price',
                        type: InputType.NUMBER,
                        hostClass: 'col-xl-12 form-control',
                    },
                },
            },
            {
                key: 'description',
                controlType: 'group',
                class: 'row',
                controls: {
                    description: {
                        controlType: 'control',
                        formControlType: FormControlType.TEXTAREA,
                        validationRules: [{name: ValidationRules.IS_REQUIRED, params: {}}],
                        placeholder: 'modal.createExtra.placeholders.description',
                        isLabelHidden: false,
                        label: 'modal.createExtra.inputs.description',
                        type: InputType.TEXT,
                        hostClass: 'col-xl-12 form-control',
                    },
                },
            },
        ],
    };
};
